import React, { useEffect, useState } from 'react';
import { add } from 'date-fns';
import { Formik } from 'formik';
import { Box, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import { useHistory, useParams } from 'react-router-dom';
import { ActivityIndicator } from 'components';
import { taskPriorities, taskTypes } from 'constants/tasks';
import { useCreateTask, useDebtorInfo } from 'hooks/api/cascade';
import { useFullNameUser } from 'screens/ProfileScreen/entities/user';
import { userStore } from 'stores';
import { validationSchema } from './NewTaskScreen.mock';
import { EditForm } from './components';

const initialValues = {
  content: '',
  type: taskTypes[1].value,
  assignees: [],
  customer: null,
  due: add(new Date(), { days: 1 }),
  priority: taskPriorities[1].id,
};

const NewTaskScreen = observer(() => {
  const history = useHistory();
  const { entityId } = useParams();
  const [stateInitialValues, setStateInitialValues] = useState(initialValues);
  const { mutate } = useCreateTask(entityId);
  const { user } = userStore;
  const username = user.uname ?? user.username;
  const { fullName } = useFullNameUser();
  const {
    isLoading: isDebtorLoading,
    isError: isDebtorError,
    isSuccess: isDebtorSuccess,
    error: debtorError,
    data: debtorInfo,
  } = useDebtorInfo(entityId);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isDebtorError) {
      enqueueSnackbar(debtorError.message, { variant: 'error' });
    }
  }, [isDebtorError]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isDebtorSuccess) {
      setStateInitialValues({
        ...stateInitialValues,
        customer: debtorInfo.debitor,
      });
    }
  }, [isDebtorSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBackClick = () => {
    history.goBack();
  };

  const handleSubmit = (data) => {
    mutate(data);
  };

  if (isDebtorLoading) {
    return <ActivityIndicator />;
  }

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item xs={11}>
        <Box pb={2}>
          <Formik
            initialValues={stateInitialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {(formikBag) => (
              <EditForm
                username={username}
                userFullName={fullName}
                formikBag={formikBag}
                onCancel={handleBackClick}
              />
            )}
          </Formik>
        </Box>
      </Grid>
    </Grid>
  );
});

export default NewTaskScreen;
